import { AnyAction } from 'redux';
import * as actionTypes from './users.actions';
import { User } from '../model/types';

type UsersState = {
  list: User[];
  byId: Record<string, User>;
};

const initialState: UsersState = {
  list: [],
  byId: {},
};

const usersReducer = (
  state: UsersState = initialState,
  action: AnyAction
): UsersState => {
  switch (action.type) {
    case actionTypes.USERS_GET: {
      const { users } = action.payload;
      const list = [...users];
      const byId = list.reduce((acc: Record<string, User>, user: User) => {
        acc[user._id] = user;
        return acc;
      }, {});

      return {
        ...state,
        list,
        byId,
      };
    }

    case actionTypes.USERS_CREATE: {
      const newUser = action.payload;
      const list = [...state.list, newUser];
      const byId = { ...state.byId, [newUser._id]: newUser };

      return {
        ...state,
        list,
        byId,
      };
    }

    case actionTypes.USERS_DELETE: {
      const list = state.list.filter(user => user._id !== action.payload);
      const byId = { ...state.byId };
      delete byId[action.payload];

      return {
        ...state,
        list,
        byId,
      };
    }

    case actionTypes.USERS_UPDATE: {
      const updatedUser = action.payload;
      const list = state.list.map(user =>
        user._id === updatedUser._id ? { ...user, ...updatedUser } : user
      );
      const byId = {
        ...state.byId,
        [updatedUser._id]: { ...state.byId[updatedUser._id], ...updatedUser },
      };

      return {
        ...state,
        list,
        byId,
      };
    }

    default:
      return state;
  }
};

export default usersReducer;
